import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// `onSave(name)` is awaited: the dialog closes only once the write has landed, and a
// rejection keeps it open with the typed name intact and the field marked, so the
// user can retry or change it rather than type it again.
function RenameDialog({ open, onClose, onSave, initialName = '' }) {
  const [name, setName] = useState(initialName);
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleSave = async () => {
    if (!name.trim() || saving) return;
    setSaving(true);
    setFailed(false);
    try {
      await onSave(name.trim());
      onClose();
    } catch (error) {
      console.error('Error renaming chat:', error);
      setFailed(true);
    } finally {
      setSaving(false);
    }
  };

  // Some hosts keep this dialog mounted between opens, so a failed attempt's
  // marking must not outlive the dialog it was shown in.
  const requestClose = () => {
    if (saving) return;
    setFailed(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={requestClose} maxWidth="sm" fullWidth sx={{ zIndex: (theme) => theme.zIndex.modal + 4 }}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Rename Chat
        <IconButton
          aria-label="close"
          onClick={requestClose}
          disabled={saving}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          autoFocus
          margin="dense"
          label="Chat Name"
          fullWidth
          value={name}
          onChange={(e) => { setName(e.target.value); setFailed(false); }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSave();
            }
          }}
          error={failed}
          helperText={failed ? 'Rename failed. Try again; if it fails again, contact support.' : undefined}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={requestClose} disabled={saving}>Cancel</Button>
        <Button onClick={handleSave} disabled={!name.trim() || saving}>{saving ? 'Saving...' : 'Save'}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default RenameDialog; 